import * as React from 'react'
// import * as classnames from 'classnames'

import * as styles from './drawer.css'

import { injectStores, StoreComponent } from '../../../store'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { ContentChapter, ContentSubTopic, ContentSection } from '../storydocStoreContent'
import { ImgSourceCloseButton, ImgSourceOpenButton } from '../../common/elements/buttons'
import { Portal } from 'react-portal'
import posed from 'react-pose'
import bind from 'bind-decorator'

const drawerProps = {
  fadedIn: { opacity: 1, transition: { duration: 500, ease: 'easeOut' } },
  fadedAway: { opacity: 0, transition: { duration: 500, ease: 'easeIn' } }
}

const AnimatedDrawer = posed.div(drawerProps)

interface IProps {
  data: any
  isFade?: boolean
  closeOnScroll?: boolean
}

@injectStores
@observer
export class Drawer extends StoreComponent<IProps> {
  @observable expanded = false

  element: HTMLDivElement | null = null

  componentDidMount () {
    window.addEventListener('touchmove', this.closeExpanded)
  }

  componentWillUnmount () {
    window.removeEventListener('touchmove', this.closeExpanded)
  }

  @bind
  closeExpanded () {
    this.expanded = false
  }

  render () {
    // console.log('drawer data', this.props)
    let opened: JSX.Element | null = <div></div>
    let expandCloseButton: JSX.Element | null = null
    expandCloseButton = this.expanded ?
                          <ImgSourceCloseButton className={styles.expandButton} onClick={() => this.expanded = !this.expanded}/> :
                          <ImgSourceOpenButton className={styles.expandButton} onClick={() => this.expanded = !this.expanded}/>

    if (this.expanded) {
      let description
      if (this.props.data instanceof ContentChapter) {
        description = this.props.data.idx === 0 ? this.props.data.sourceOptionalBgImage : null
      } else if (this.props.data instanceof ContentSubTopic) {
        description = this.props.data.headerImageSource
      } else if (this.props.data instanceof ContentSection) {
        description = this.props.data.sourceBGImage
      }

      opened = (
          <div className={ styles.drawerContainer } style={this.store.breakpoints.phone && this.element ? { top: `calc(${this.element.getBoundingClientRect().top}px + env(safe-area-inset-top, 0px))` } : undefined}>
            {/* <div className={styles.title}>Quellenangaben</div> */}
            <div className={ styles.description }>{ description }</div>
          </div>
        )
    }

    if (this.props.data.sourceOptionalBgImage || this.props.data.headerImageSource || this.props.data.sourceBGImage) {
      return (
        <div className={styles.box} ref={elem => this.element = elem}>
          <AnimatedDrawer pose={this.props.isFade ? 'fadedAway' : 'fadedIn'}>{expandCloseButton}</AnimatedDrawer>
          { this.store.breakpoints.desktop ? opened : <Portal>{ opened }</Portal> }
        </div >
      )
    } else {
      return <div/>
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/drawer/drawer.tsx